<form (ngSubmit)="submit()" class="p-3">
  <div>
    Please submit a note to explain why this record is being moved to <span class="bold">{{ StructCapStatusLabels[newStatus] }}</span>
  </div>
  <textarea [(ngModel)]="noteModalContent" name="note-modal-content" class="w-100" rows="4"></textarea>
  <div class="d-flex flex-wrap mb-4 struct-cap-status-reason-container">
    <ng-container *ngFor="let reason of (StructCapStatusReasonLabels | keyvalue)">
      <div class="struct-cap-status-reason-pill" (click)="selectedReason = reason.key" [ngClass]="{ active: selectedReason === reason.key }">
        {{ reason.value }}
      </div>
    </ng-container>
  </div>
  <div *ngIf="dateRequired" class="mt-2 mb-4">
    <div>
      Please choose a date for reactivation:
    </div>
    <div class="d-flex">
      <rms-date-picker id="silenceUntilDate"
                       name="silenceUntilDate"
                       #silenceUntilDateRef="ngModel"
                       [(ngModel)]="silenceUntilDate"
                       [min]="curDate"
                       [isRange]="false">
      </rms-date-picker>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <button type="button" class="btn btn-default" (click)="dismiss()">Cancel</button>
    <div class="d-flex align-items-center">
      <input type="checkbox" id="email-notify" name="email-notify" [(ngModel)]="shouldSendNotification" />
      <label for="email-notify" class="text-capitalize mb-0 ml-1 mr-2">Send email with note</label>
      <button class="btn btn-primary" [disabled]="cannotSubmit">Submit</button>
    </div>
  </div>
</form>
